import axios from "axios";
import { config } from "./config";
let axiosHeaders = {
	Authorization: localStorage.getItem("authorization"),
	idToken: localStorage.getItem("idtoken"),
	"auth-token": sessionStorage.getItem("auth-token"),
};
const getHeaders = () => {
	return axiosHeaders;
};
const clearHeaders = () => {
	axiosHeaders = {
		Authorization: null,
		idToken: null,
		"auth-token": null,
	};
	localStorage.removeItem("authorization");
	localStorage.removeItem("idtoken");
	sessionStorage.removeItem("auth-token");
	sessionStorage.removeItem("studentEmail");
};
const setHeaders = (h) => {
	console.log("Setting headers");
	axiosHeaders = { ...axiosHeaders, ...h };
	localStorage.removeItem("authorization");
	localStorage.setItem("authorization", h.Authorization);
	localStorage.removeItem("idtoken");
	localStorage.setItem("idtoken", h.idToken);

	API = axios.create({
		baseURL: config.apiUrl,
		headers: getHeaders(),
	});
	console.log("Headers: ", getHeaders());
};
const getStudentEmail = () => {
	return sessionStorage.getItem("studentEmail");
};
const setStudentEmail = (email) => {
	sessionStorage.removeItem("studentEmail");
	sessionStorage.setItem("studentEmail", email);
};
const setNirvToken = (token) => {
	console.log("Setting nirv token");
	axiosHeaders = {
		...axiosHeaders,
		"auth-token": token,
	};
	sessionStorage.removeItem("auth-token");
	sessionStorage.setItem("auth-token", token);

	API = axios.create({
		baseURL: config.apiUrl,
		headers: getHeaders(),
	});
	console.log("Headers: ", getHeaders());
};
let API = axios.create({
	baseURL: config.apiUrl,
	headers: getHeaders(),
});

export { API, setHeaders, setNirvToken, getStudentEmail, setStudentEmail, clearHeaders };
